import { isEqual } from 'lodash'
import { Moment } from 'moment'
import { useFormContext } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { selectAssetDetailPage } from 'store/asset/selectors'

import { FIELD_NAMES } from '../validation'

export const useResidualUsagePeriodDefault = (usagePeriodMonths?: number | null) => {
  const { watch } = useFormContext()
  const impairmentAt = watch(FIELD_NAMES.impaired_at) as Moment
  const { asset } = useSelector(selectAssetDetailPage, isEqual)

  if (!asset.usage_started_at || !impairmentAt || !usagePeriodMonths) return 1

  const numberMonths = impairmentAt?.diff(asset.usage_started_at, 'months')

  return Math.max(1, usagePeriodMonths - numberMonths)
}
